var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorState500(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 201,
    viewBox: "0 0 201 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.034 25.4657C98.1538 25.7211 84.9921 33.0262 76.7436 44.184C69.6401 53.793 58.5831 59.7958 46.6339 59.7895C46.2831 59.7891 45.9319 59.793 45.5792 59.8008C21.3933 60.3297 0.826852 81.0813 0.504196 105.271C0.160837 131.025 20.9347 152.011 46.6104 152.011C66.5116 152.011 83.4655 139.402 89.9249 121.738C91.6155 117.116 96.6253 114.639 101.364 115.968C101.423 115.985 101.482 116.001 101.541 116.018C105.877 117.214 108.751 121.346 108.396 125.83C107.921 131.839 108.624 138.039 110.662 144.109C118.678 167.99 144.719 181.095 168.667 173.281C193.164 165.287 206.315 138.834 198.01 114.531C193.39 101.011 183.112 91.0305 170.725 86.3262C164.307 83.8891 160.042 77.7887 159.948 70.9246C159.946 70.7747 159.943 70.6243 159.94 70.4735C159.358 45.5125 138.705 25.4598 113.83 25.4586C113.565 25.4586 113.301 25.461 113.034 25.4657Z",
    fill: "url(#paint0_linear_5520_217541)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5520_217541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 201,
    height: 201
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.500015H200.5V200.5H0.5V0.500015Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5520_217541)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5520_217541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 15,
    width: 157,
    height: 66
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.375 15.4568H178.625V80.0818H22.375V15.4568Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5520_217541)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.100006
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.625 80.0815V43.7616C178.625 40.5276 176 37.9022 172.766 37.9022H116.074L103.857 17.3659C102.343 14.8202 98.657 14.8202 97.143 17.3659L84.9266 37.9022H28.2344C25 37.9022 22.375 40.5276 22.375 43.7616V80.0815H178.625Z",
    fill: "#005B99"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.653 185.542H78.3477L87.2078 150.423H113.793L122.653 185.542Z",
    fill: "#8AB4D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.877 162.651H84.1211L87.2066 150.423H113.792L116.877 162.651Z",
    fill: "#005B99"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.625 51.9666V151.283C178.625 154.517 176 157.142 172.766 157.142H28.2344C25 157.142 22.375 154.517 22.375 151.283V51.9666C22.375 48.7322 25 46.1072 28.2344 46.1072H172.766C176 46.1072 178.625 48.7322 178.625 51.9666Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6349 113.849H146.366C149.396 113.849 151.272 110.549 149.723 107.946L103.858 30.8428C102.343 28.2971 98.6576 28.2971 97.1435 30.8428L51.2779 107.946C49.7287 110.549 51.6052 113.849 54.6349 113.849Z",
    fill: "#B0CCDF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M178.625 81.2534V51.9663C178.625 48.7319 176 46.1069 172.766 46.1069H28.2344C25 46.1069 22.375 48.7319 22.375 51.9663V81.2534H178.625Z",
    fill: "#FFEDEF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M178.625 64.9241V51.9667C178.625 48.7303 176.002 46.1073 172.766 46.1073H28.2344C24.9984 46.1073 22.375 48.7303 22.375 51.9667V64.9241H178.625Z",
    fill: "#337CAD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.375 64.9241H178.625",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1066 174.606L87.2074 150.423H113.793L122.652 185.542H78.3477",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.375 137.458V151.282C22.375 154.518 24.9984 157.141 28.2344 157.141H172.766C176.002 157.141 178.625 154.518 178.625 151.282V137.458H22.375Z",
    fill: "#8AB4D0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M178.409 137.458H22.375",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8389 185.54H130.162",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.251 55.4865V55.5439",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7988 55.4865V55.5439",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3477 55.4865V55.5439",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4844 46.1072H28.2344C24.9984 46.1072 22.375 48.7302 22.375 51.9666V151.282C22.375 154.518 24.9984 157.141 28.2344 157.141H172.766C176.002 157.141 178.625 154.518 178.625 151.282V51.9666C178.625 48.7302 176.002 46.1072 172.766 46.1072H126.81",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6349 108.575H146.366C149.396 108.575 151.272 105.276 149.723 102.672L103.858 25.5693C102.343 23.0236 98.6576 23.0236 97.1435 25.5693L51.2779 102.672C49.7287 105.276 51.6052 108.575 54.6349 108.575Z",
    fill: "#F06677"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6349 108.575H146.366C149.396 108.575 151.272 105.276 149.723 102.672L103.858 25.5693C102.343 23.0236 98.6576 23.0236 97.1435 25.5693L51.2779 102.672C49.7287 105.276 51.6052 108.575 54.6349 108.575Z",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M100.5 82.479C98.343 82.479 96.5938 80.7302 96.5938 78.5728V52.8892C96.5938 50.7321 98.343 48.9829 100.5 48.9829C102.657 48.9829 104.406 50.7321 104.406 52.8892V78.5728C104.406 80.7302 102.657 82.479 100.5 82.479Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M100.5 94.611C98.343 94.611 96.5938 92.8621 96.5938 90.7047V90.6598C96.5938 88.5024 98.343 86.7535 100.5 86.7535C102.657 86.7535 104.406 88.5024 104.406 90.6598V90.7047C104.406 92.8621 102.657 94.611 100.5 94.611Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5873 118.61C46.9096 120.288 44.1889 120.288 42.5107 118.61C44.1889 120.288 44.1889 123.008 42.5107 124.686C44.1889 123.008 46.9092 123.008 48.5873 124.686C46.9092 123.008 46.9096 120.288 48.5873 118.61Z",
    stroke: "#F06677",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4734 118.61C62.7953 120.288 60.0746 120.288 58.3965 118.61C60.0746 120.288 60.0746 123.008 58.3965 124.686C60.0746 123.008 62.7953 123.008 64.4734 124.686C62.7953 123.008 62.7953 120.288 64.4734 118.61Z",
    stroke: "#F06677",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3582 118.61C78.6801 120.288 75.9594 120.288 74.2812 118.61C75.9594 120.288 75.9594 123.008 74.2812 124.686C75.9594 123.008 78.6801 123.008 80.3582 124.686C78.6801 123.008 78.6801 120.288 80.3582 118.61Z",
    stroke: "#F06677",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M156.532 119.91H95.1441C94.0633 119.91 93.1875 119.034 93.1875 117.954C93.1875 116.874 94.0633 115.997 95.1441 115.997H156.532C157.613 115.997 158.489 116.874 158.489 117.954C158.489 119.034 157.613 119.91 156.532 119.91Z",
    fill: "#B0CCDF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M156.532 127.298H95.1441C94.0633 127.298 93.1875 126.423 93.1875 125.342C93.1875 124.262 94.0633 123.386 95.1441 123.386H156.532C157.613 123.386 158.489 124.262 158.489 125.342C158.489 126.423 157.613 127.298 156.532 127.298Z",
    fill: "#B0CCDF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6516 176.591L52.3477 172.287L56.6516 167.983L60.9559 172.287L56.6516 176.591Z",
    stroke: "#F599A4",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M125.837 31.3659L121.533 27.062L125.837 22.7581L130.141 27.062L125.837 31.3659Z",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M143.072 15.4572C143.072 17.8341 141.145 19.7611 138.768 19.7611C141.145 19.7611 143.072 21.688 143.072 24.065C143.072 21.688 144.999 19.7611 147.376 19.7611C144.999 19.7611 143.072 17.8341 143.072 15.4572Z",
    stroke: "#005B99",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4738 22.7581C64.4738 25.135 62.5469 27.062 60.1699 27.062C62.5469 27.062 64.4738 28.989 64.4738 31.3659C64.4738 28.989 66.4008 27.062 68.7781 27.062C66.4008 27.062 64.4738 25.135 64.4738 22.7581Z",
    stroke: "#8AB4D0",
    strokeWidth: 3.90625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5520_217541",
    x1: 196.333,
    y1: 165.931,
    x2: 11.9194,
    y2: 211.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorState500);
export default __webpack_public_path__ + "static/media/error-state-500.9cd65bc079751f723cccd9f19979c085.svg";
export { ForwardRef as ReactComponent };